import { createRoute, lazyRouteComponent } from "@tanstack/react-router"

import { rootRoute } from "./rootRoute"
import { oneOf, searchSchema, text } from "./searchSchema"

const AllocationsPage = lazyRouteComponent(() => import("#Pages/AllocationsPage/AllocationsPage"))
const AddDashboardPage = lazyRouteComponent(
  () => import("#Pages/AddDashboardPage/AddDashboardPage"),
)
const AnomalyIncidentsPage = lazyRouteComponent(
  () => import("#Pages/AnomalyIncidentsPage/AnomalyIncidentsPage"),
)
const AnomalyIncidentPage = lazyRouteComponent(
  () => import("#Pages/AnomalyIncidentPage/AnomalyIncidentPage"),
)
const AnomalyIncidentAlertsPage = lazyRouteComponent(
  () => import("#Pages/AnomalyIncidentAlertsPage/AnomalyIncidentAlertsPage"),
)
const AnomalyIncidentAlertPage = lazyRouteComponent(
  () => import("#Pages/AnomalyIncidentAlertPage/AnomalyIncidentAlertPage"),
)
const AnomalyIncidentLogbookPage = lazyRouteComponent(
  () => import("#Pages/AnomalyIncidentLogbookPage/AnomalyIncidentLogbookPage"),
)
const AnomalyIncidentGraphsPage = lazyRouteComponent(
  () => import("#Pages/AnomalyIncidentGraphsPage"),
)
const DashboardShow = lazyRouteComponent(() => import("#Pages/dashboard/show"))
const EventGroupShow = lazyRouteComponent(() => import("#Pages/event_group/show"))
const EventPage = lazyRouteComponent(() => import("#Pages/EventPage/EventPage"))
const EventsIndex = lazyRouteComponent(() => import("#Pages/events/index"))
const ExceptionIncidentsGraphs = lazyRouteComponent(
  () => import("#Pages/exception_incidents/graphs"),
)
const ExceptionIncidentsPage = lazyRouteComponent(
  () => import("#Pages/ExceptionIncidentsPage/ExceptionIncidentsPage"),
)
const ExceptionIncidentPage = lazyRouteComponent(
  () => import("#Pages/ExceptionIncidentPage/ExceptionIncidentPage"),
)
const BrowserErrorsPage = lazyRouteComponent(
  () => import("#Pages/BrowserErrorsPage/BrowserErrorsPage"),
)
const BrowserPerformancePage = lazyRouteComponent(
  () => import("#Pages/BrowserPerformancePage/BrowserPerformancePage"),
)
const HostMetricsPage = lazyRouteComponent(() => import("#Pages/HostMetricsPage/HostMetricsPage"))
const HostMetricsInspectPage = lazyRouteComponent(
  () => import("#Pages/HostMetricsPage/HostMetricsInspectPage"),
)
const HostUsagePage = lazyRouteComponent(() => import("#Pages/HostUsagePage/HostUsagePage"))
const HostUsageInspectPage = lazyRouteComponent(
  () => import("#Pages/HostUsagePage/HostUsageInspectPage"),
)
const MarkersIndex = lazyRouteComponent(() => import("#Pages/markers/index"))
const MarkerShowPage = lazyRouteComponent(() => import("#Pages/MarkerShowPage/MarkerShowPage"))
const MetricsIndex = lazyRouteComponent(() => import("#Pages/metrics/index"))
const AnomalyDetectionPage = lazyRouteComponent(
  () => import("#Pages/AnomalyDetectionPage/AnomalyDetectionPage"),
)
const AnomalyDetectionTriggersPage = lazyRouteComponent(
  () => import("#Pages/TriggersPage/AnomalyDetectionTriggersPage"),
)
const AnomalyDetectionTriggerPage = lazyRouteComponent(
  () => import("#Pages/TriggersPage/AnomalyDetectionTriggerPage"),
)
const AnalysisReplayPage = lazyRouteComponent(
  () => import("#Pages/AnalysisReplayPage/AnalysisReplayPage"),
)
const AddAppPage = lazyRouteComponent(() => import("#Pages/sites/AddAppPage"))
const NewSiteJs = lazyRouteComponent(() => import("#Pages/sites/NewSiteJs"))
const BrowserSdkWizard = lazyRouteComponent(() => import("#Pages/sites/browser/BrowserSdkWizard"))
const ProvisioningPage = lazyRouteComponent(
  () => import("#Pages/sites/provisioning/ProvisioningPage"),
)
const ClusterNodeMetricsPage = lazyRouteComponent(
  () => import("#Pages/ClusterNodeMetricsPage/ClusterNodeMetricsPage"),
)
const ClusterOverviewPage = lazyRouteComponent(
  () => import("#Pages/ClusterOverviewPage/ClusterOverviewPage"),
)
const ClusterNodeMetricsInspectPage = lazyRouteComponent(
  () => import("#Pages/ClusterNodeMetricsInspectPage/ClusterNodeMetricsInspectPage"),
)
const OrganizationsPage = lazyRouteComponent(
  () => import("#Pages/OrganizationsPage/OrganizationsPage"),
)
const PerformanceApdexPage = lazyRouteComponent(
  () => import("#Pages/PerformanceApdexPage/PerformanceApdexPage"),
)
const PerformanceIncidentsGraphs = lazyRouteComponent(
  () => import("#Pages/performance_incidents/graphs"),
)
const PerformanceIncidentsPage = lazyRouteComponent(
  () => import("#Pages/PerformanceIncidentsPage/PerformanceIncidentsPage"),
)
const PerformanceIncidentPage = lazyRouteComponent(
  () => import("#Pages/PerformanceIncidentPage/PerformanceIncidentPage"),
)
const PerformanceIncidentSamplesPage = lazyRouteComponent(
  () => import("#Pages/PerformanceIncidentSamplesPage/PerformanceIncidentSamplesPage"),
)
const PerformanceIncidentGraphsPage = lazyRouteComponent(
  () => import("#Pages/PerformanceIncidentGraphsPage/PerformanceIncidentGraphsPage"),
)
const PerformanceIncidentLogbookPage = lazyRouteComponent(
  () => import("#Pages/PerformanceIncidentLogbookPage/PerformanceIncidentLogbookPage"),
)
const PerformanceIncidentSamplePage = lazyRouteComponent(
  () => import("#Pages/PerformanceIncidentSamplePage/PerformanceIncidentSamplePage"),
)
const PerformanceTracingActionsPage = lazyRouteComponent(
  () => import("#Pages/PerformanceTracingActionsPage/PerformanceTracingActionsPage"),
)
const PerformanceTracingActionPage = lazyRouteComponent(
  () => import("#Pages/PerformanceTracingActionPage/PerformanceTracingActionPage"),
)
const PerformanceTracingTracesPage = lazyRouteComponent(
  () => import("#Pages/PerformanceTracingTracesPage/PerformanceTracingTracesPage"),
)
const PerformanceTracingTracePage = lazyRouteComponent(
  () => import("#Pages/PerformanceTracingTracePage/PerformanceTracingTracePage"),
)
const PerformanceTracingGraphsPage = lazyRouteComponent(
  () => import("#Pages/PerformanceTracingGraphsPage/PerformanceTracingGraphsPage"),
)
const PerformanceTracingLogbookPage = lazyRouteComponent(
  () => import("#Pages/PerformanceTracingLogbookPage/PerformanceTracingLogbookPage"),
)
const ClusterPodMetricsPage = lazyRouteComponent(
  () => import("#Pages/ClusterPodMetricsPage/ClusterPodMetricsPage"),
)
const ClusterPodMetricsInspectPage = lazyRouteComponent(
  () => import("#Pages/ClusterPodMetricsInspectPage/ClusterPodMetricsInspectPage"),
)
const SiteNew = lazyRouteComponent(() => import("#Pages/sites/NewSite"))
const SiteCreate = lazyRouteComponent(() => import("#Pages/sites/CreateApp"))
const TriggersPage = lazyRouteComponent(() => import("#Pages/TriggersPage"))
const UptimeMonitorPage = lazyRouteComponent(
  () => import("#Pages/UptimeMonitorPage/UptimeMonitorPage"),
)
const AssignmentsPage = lazyRouteComponent(() => import("#Pages/AssignmentsPage/AssignmentsPage"))
const StatusPagesPage = lazyRouteComponent(() => import("#Pages/StatusPagesPage/StatusPagesPage"))
const OrganizationPage = lazyRouteComponent(
  () => import("#Pages/OrganizationPage/OrganizationPage"),
)
const LogsPage = lazyRouteComponent(() => import("#Pages/LogsPage/LogsPage"))
const LogsTriggersPage = lazyRouteComponent(
  () => import("#Pages/LogsTriggersPage/LogsTriggersPage"),
)
const LogLineActionsPage = lazyRouteComponent(
  () => import("#Pages/LogLineActionsPage/LogLineActionsPage"),
)
const SourcesPage = lazyRouteComponent(() => import("#Pages/SourcesPage/SourcesPage"))
const SourcePage = lazyRouteComponent(() => import("#Pages/SourcePage/SourcePage"))
const ExceptionIncidentTracesPage = lazyRouteComponent(
  () => import("#Pages/ExceptionIncidentTracesPage/ExceptionIncidentTracesPage"),
)
const ExceptionIncidentTracePage = lazyRouteComponent(
  () => import("#Pages/ExceptionIncidentTracePage/ExceptionIncidentTracePage"),
)
const ExceptionIncidentTraceTimestampPage = lazyRouteComponent(
  () => import("#Pages/ExceptionIncidentTraceTimestampPage/ExceptionIncidentTraceTimestampPage"),
)
const ExceptionIncidentGraphsPage = lazyRouteComponent(
  () => import("#Pages/ExceptionIncidentGraphsPage"),
)
const ExceptionIncidentAttributesPage = lazyRouteComponent(
  () => import("#Pages/ExceptionIncidentAttributesPage/ExceptionIncidentAttributesPage"),
)
const ExceptionIncidentLogbookPage = lazyRouteComponent(
  () => import("#Pages/ExceptionIncidentLogbookPage/ExceptionIncidentLogbookPage"),
)
const LogsIncidentsPage = lazyRouteComponent(
  () => import("#Pages/LogsIncidentsPage/LogsIncidentsPage"),
)
const LogsIncidentPage = lazyRouteComponent(
  () => import("#Pages/LogsIncidentPage/LogsIncidentPage"),
)
const LogsIncidentLogbookPage = lazyRouteComponent(
  () => import("#Pages/LogsIncidentLogbookPage/LogsIncidentLogbookPage"),
)
const LogsIncidentGraphsPage = lazyRouteComponent(() => import("#Pages/LogsIncidentGraphsPage"))
const LogsIncidentLinesPage = lazyRouteComponent(
  () => import("#Pages/LogsIncidentLinesPage/LogsIncidentLinesPage"),
)
const CheckInsPage = lazyRouteComponent(() => import("#Pages/CheckInsPage/CheckInsPage"))
const CheckInPage = lazyRouteComponent(() => import("#Pages/CheckInPage/CheckInPage"))
const CheckInLogbookPage = lazyRouteComponent(
  () => import("#Pages/CheckInLogbookPage/CheckInLogbookPage"),
)
const CheckInOccurrencesPage = lazyRouteComponent(
  () => import("#Pages/CheckInOccurrencesPage/CheckInOccurrencesPage"),
)
const CheckInOccurrencePage = lazyRouteComponent(
  () => import("#Pages/CheckInOccurrencePage/CheckInOccurrencePage"),
)
const CheckInInstallationPage = lazyRouteComponent(
  () => import("#Pages/CheckInInstallationPage/CheckInInstallationPage"),
)
const CsvExportsPage = lazyRouteComponent(() => import("#Pages/CsvExportsPage/CsvExportsPage"))
const DiscoverPage = lazyRouteComponent(() => import("#Pages/DiscoverPage/DiscoverPage"))

// React routes live here as real TanStack `createRoute` instances with literal
// `$param` paths, so `route.useParams()` and `route.useSearch()` carry full
// inference. `staticData.componentName` names the page for analytics and for
// the menu/chrome that `RootLayout` derives from the active leaf.
//
// Most pages live under `:organizationSlug/sites/:appId/...`. Rather than
// repeat that prefix on every leaf route, `orgLayoutRoute` and `appLayoutRoute`
// own the shared segments — leaves slot in as descendants and inherit typed
// `organizationSlug` / `appId` params automatically. They carry no
// `staticData.componentName` and no `component`, so a bare layout URL
// (e.g. /myorg/sites/abc with no further segment) matches no page and reloads
// to Rails via `rootRoute.notFoundComponent`.
//
// Adding a migration:
// 1. Write a `createRoute({...})` here with the TanStack path. Pick the
//    matching layout parent: `appLayoutRoute` for app-scoped pages,
//    `orgLayoutRoute` for org-scoped pages, `rootRoute` for top-level pages.
//    Set `path` to the *segment after* the layout (e.g. `"markers"`, not
//    `"/$organizationSlug/sites/$appId/markers"`).
// 2. Set `staticData.componentName` to the page's component name.
// 3. Nest it into `ROUTE_TREE` under its layout parent.
// 4. In the page body, read params/search via `useCurrentParams()` /
//    `useCurrentSearch()` from `#Root/router/typedRouteHooks`.

// --- Layout routes -------------------------------------------------------

export const orgLayoutRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "$organizationSlug",
})

export const appLayoutRoute = createRoute({
  getParentRoute: () => orgLayoutRoute,
  path: "sites/$appId",
})

// Nested layout for the check-in detail tree. 5 routes share the
// `monitors/$triggerId` prefix (the index page `CheckInPage` plus 4 sub-tabs:
// occurrences, occurrence, logbook, installation). The detail page sits at the
// layout's bare path — that's expressed as `path: "/"` on the leaf
// (`checkInDetailRoute` below).
//
// Pattern reference for future migrations: incident clusters
// (`exceptions/incidents/$number`, `performance/incidents/$number`,
// `logs/incidents/$number`, `performance/traces/$namespace/$action`) share
// this same shape — an entity with N sub-tabs, all rendering a shared
// header/pagebar. `anomalyIncidentLayoutRoute` below mirrors it. Past the
// renderer flip (README Phase 6), the shared pagebar component moves into
// `layout.component` so the leaves stop repeating it.
export const checkInLayoutRoute = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: "monitors/$triggerId",
})

// Nested layout for the anomaly incident detail tree. Same shape as
// `checkInLayoutRoute`: index page (`AnomalyIncidentPage`) at `path: "/"`
// plus 4 sub-tabs (alerts, alerts/$id, graphs, logbook). The index page
// (`AnomalyIncidentsPage`, plural) sits separately under `appLayoutRoute`
// since it has no `$number`.
export const anomalyIncidentLayoutRoute = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: "anomalies/incidents/$number",
})

export const logsIncidentLayoutRoute = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: "logs/incidents/$number",
})

export const exceptionIncidentLayoutRoute = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: "exceptions/incidents/$number",
})

export const performanceIncidentLayoutRoute = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: "performance/incidents/$number",
})

export const performanceTracingActionLayoutRoute = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: "performance/traces/$namespace/$action",
})

// --- Search declarations -------------------------------------------------

// Every route declares its search with `searchSchema` — see `searchSchema.ts`
// for the four rules and why they are what they are. The blanket
// `validateSearchStrings` this replaced asserted a per-route type over a
// `String()`-everything coercion, so the declared type was a claim rather than
// a check, and a key nobody declared was indistinguishable from one that did
// not exist.
//
// **`text` is the default; `oneOf` needs a reason.** A narrowed key rejects a
// value outside its set, and rule 3 makes that rejection override the raw value
// the parent match merged in. That is the point for a page's own select, and a
// bug for anything else, so narrow only a key that is
//
//   - written by this page's own controls,
//   - closed at its consumer — the apdex overlay's `mode` prop *is*
//     `"new" | "edit"` — rather than listed in a page the set can grow with (a
//     duplicated list silently rejects the option the page adds next, which is
//     why the trigger `form` key and the cluster `groupBy` key stay `text`),
//   - URL-only: a dual-backed key (URL + cookie, through `usePersistedParams`)
//     stays `text`, because the cookie holds a plain string and narrowing would
//     make the cookie half unrepresentable, and
//   - not a key a *global* consumer reads on this route.
//
// That last rule is what keeps `overlay` `text` on every route. `?overlay=…` is
// global: `RootLayout` renders the search overlay's hotkey and link, and a chart
// action opens the trigger form from any page. A route that narrows `overlay`
// swallows every overlay it forgot to name — rule 3 replaces the parent's raw
// value with `undefined`, so `GlobalOverlays` sees no overlay at all. The keys
// those overlays carry alongside it (`form`, `state`, `id`, `triggerId`) are
// global on the same routes for the same reason.

// A one-shot blank-slate override. `"true"` forces the blank slate on (what the
// marketing/empty-state links pass); `"hidden"` is what a page's own blank slate
// writes to dismiss itself. Shared by every index page that has one — and every
// read compares against these two, so a third value already meant the same as
// no value.
const BLANK_SLATE_STATES = ["true", "hidden"] as const

// Selects the form variant in `CheckInFormOverlay` (cron vs heartbeat). Written
// by the overlay's tab links, read via `getParams().kind`.
const CHECK_IN_KINDS = ["cron", "heartbeat"] as const

// Which pane the error inspector shows (`ErrorInspector.tsx:102`). Was read and
// written by the page and declared in its `persistedKeys`, but on no route.
const BROWSER_ERROR_TABS = ["sample", "logbook"] as const

// Whether the apdex overlay edits a namespace's existing configuration or
// creates one. `ApdexConfigurationOverlay` closes the set with its own prop
// type, and `mode === "edit"` is its only read of the key.
const APDEX_MODES = ["new", "edit"] as const

// --- Shared field groups -------------------------------------------------

// The date-range picker's three keys. `timeframe` names a preset (`"R4H"`) or
// `"custom"`, in which case `from`/`to` carry the absolute range. `timeframe` is
// dual-backed on nearly every page that has it, so all three stay `text`.
const timeRangeFields = {
  timeframe: text,
  from: text,
  to: text,
}

// The picker plus the resolution select the charting pages add to it — what the
// `DateRangeSearch` alias used to spell out.
const dateRangeFields = {
  ...timeRangeFields,
  chartResolution: text,
}

// A graphs or inspect tab: the date range plus the column-count select.
// `columns` is cookie-backed on most of these pages and cookie-*only* on the
// inspect pages, so it stays `text`.
const graphsFields = {
  ...dateRangeFields,
  columns: text,
}

// The incident list filters. The multi-selects hold one comma-joined string
// (`arrayToParam` in the pages) and all three are dual-backed, so they stay
// `text`.
const incidentFilterFields = {
  incident_status: text,
  incident_severity: text,
  incident_assignee: text,
}

// `overlay` + `checkInTriggerId` open `CheckInFormOverlay`; `blankSlate` is read
// at `CheckInsPage.jsx:51`.
//
// `states` (on the occurrences route below) stays `text`: it is dual-backed
// through `usePersistedParams`, so the page reads it off the persisted-params
// blob and the cookie holds the same comma-joined string.
const checkInsSearchFields = {
  overlay: text,
  checkInTriggerId: text,
  kind: oneOf(CHECK_IN_KINDS),
  blankSlate: oneOf(BLANK_SLATE_STATES),
}

// --- Per-route search declarations ---------------------------------------

const validateMarkersSearch = searchSchema({
  ...timeRangeFields,
  revision: text,
  namespaces: text,
})

// Trigger links can carry form values across apps through `/redirect-to/app`.
// The overlay can also open on other routes, where these keys pass through as
// strings. `field` serves several form types, so it has no single enum.
const TRIGGER_COMPARISON_OPERATORS = [
  "GREATER_THAN",
  "LESS_THAN",
  "EQUAL",
  "NOT_EQUAL",
  "GREATER_THAN_OR_EQUAL",
  "LESS_THAN_OR_EQUAL",
] as const
const HOST_METRIC_STATES = [
  "total_usage",
  "nice",
  "idle",
  "steal",
  "system",
  "iowait",
  "user",
  "usage",
  "used",
  "free",
] as const
const VALUE_FORMATS = ["number", "percent", "duration", "throughput", "size"] as const
const VALUE_FORMAT_INPUTS = ["bit", "byte", "kilobit", "kilobyte", "megabyte"] as const

const validateTriggersSearch = searchSchema({
  blankSlate: oneOf(BLANK_SLATE_STATES),
  form: text,
  triggerId: text,
  namespace: text,
  actionName: text,
  hostname: text,
  mountpoint: text,
  metricName: text,
  name: text,
  tags: text,
  field: text,
  conditionValue: text,
  description: text,
  dashboardId: text,
  disabledFields: text,
  warmupDuration: text,
  cooldownDuration: text,
  comparisonOperator: oneOf(TRIGGER_COMPARISON_OPERATORS),
  state: oneOf(HOST_METRIC_STATES),
  format: oneOf(VALUE_FORMATS),
  formatInput: oneOf(VALUE_FORMAT_INPUTS),
  noMatchIsZero: oneOf(["true", "false"]),
})

// `overlay` selects which overlay the metrics page mounts (visual builder,
// dashboard form, etc.).
const validateMetricsSearch = searchSchema({
  overlay: text,
})

const validateStatusPagesSearch = searchSchema({
  overlay: text,
  organizationSlug: text,
  statusPageId: text,
  statusPageUpdateId: text,
})

const validateCheckInsSearch = searchSchema(checkInsSearchFields)

const validateCheckInOccurrencesSearch = searchSchema({
  ...checkInsSearchFields,
  ...timeRangeFields,
  states: text,
})

const validateAnomalyIncidentsSearch = searchSchema({
  ...incidentFilterFields,
  blankSlate: oneOf(BLANK_SLATE_STATES),
  alert_status: text,
})

const validateAnomalyIncidentAlertsSearch = searchSchema({
  alert_state: text,
})

const validateAnomalyIncidentGraphsSearch = searchSchema(graphsFields)

// The logs page keeps its whole view configuration in the URL so a view can be
// shared: the query and its window, the visible columns, the chart and wrapping
// toggles, and the inspector's selection. `normalizeParams` in the page owns
// the defaults, which is why none of these narrow.
const validateLogsSearch = searchSchema({
  ...timeRangeFields,
  blankSlate: oneOf(BLANK_SLATE_STATES),
  clamp: text,
  columns: text,
  defaultMeasureField: text,
  id: text,
  logLineContext: text,
  overlay: text,
  query: text,
  queryWindow: text,
  severities: text,
  showChart: text,
  sourceIds: text,
  timestamp: text,
  viewName: text,
  visibleColumns: text,
  wrapLines: text,
})

const validateLogsTriggersSearch = searchSchema({
  blankSlate: oneOf(BLANK_SLATE_STATES),
  timestamp: text,
  overlay: text,
  id: text,
  query: text,
  sourceIds: text,
  userId: text,
})

const validateLogLineActionsSearch = searchSchema({
  overlay: text,
  id: text,
  visualId: text,
  metricName: text,
  triggerId: text,
  form: text,
})

const validateSourcesSearch = searchSchema({
  overlay: text,
  logSourceId: text,
  blankSlate: oneOf(BLANK_SLATE_STATES),
})

const validateSourceSearch = searchSchema({
  overlay: text,
  logSourceId: text,
  jobId: text,
})

// Shared by the routes whose only search state is the date range (events, slow
// events, the action detail page).
const validateDateRangeSearch = searchSchema(dateRangeFields)

const validateUptimeMonitorsSearch = searchSchema({
  ...dateRangeFields,
  blankSlate: oneOf(BLANK_SLATE_STATES),
  overlay: text,
})

const validateLogsIncidentsSearch = searchSchema(incidentFilterFields)

const validateLogsIncidentSearch = searchSchema({
  overlay: text,
  id: text,
})

const validateLogsIncidentGraphsSearch = searchSchema(graphsFields)

const validateExceptionIncidentsSearch = searchSchema({
  ...incidentFilterFields,
  query: text,
  incident_order: text,
  incident_marker: text,
  namespaces: text,
})

const validateExceptionIncidentsGraphsSearch = searchSchema({
  ...graphsFields,
  namespaces: text,
})

const validateExceptionIncidentGraphsSearch = searchSchema(graphsFields)

const validateExceptionIncidentTracesSearch = searchSchema({
  query: text,
  time: text,
})

const validateExceptionIncidentTraceSearch = searchSchema({
  activeFilter: text,
  redirectedFrom: text,
  selectedTime: text,
  traceFilter: text,
})

const validatePerformanceIncidentsSearch = searchSchema({
  ...incidentFilterFields,
  query: text,
  incident_marker: text,
  namespaces: text,
})

const validatePerformanceIncidentsGraphsSearch = searchSchema({
  ...graphsFields,
  namespaces: text,
})

// `overlay` stays `text` per the rule above; `mode` is the one narrowed key
// that travels with an overlay, because its consumer closes the set.
const validatePerformanceApdexSearch = searchSchema({
  ...dateRangeFields,
  namespace: text,
  overlay: text,
  mode: oneOf(APDEX_MODES),
})

const validatePerformanceIncidentGraphsSearch = searchSchema(graphsFields)

const validatePerformanceIncidentSamplesSearch = searchSchema({
  marker: text,
  query: text,
  time: text,
})

const validatePerformanceIncidentSampleSearch = searchSchema({
  sample_id: text,
  activeFilter: text,
  selectedTime: text,
  traceFilter: text,
})

const validatePerformanceTracingActionsSearch = searchSchema({
  ...dateRangeFields,
  query: text,
  namespaces: text,
  incident_marker: text,
})

const validatePerformanceTracingGraphsSearch = searchSchema(graphsFields)

const validatePerformanceTracingTracesSearch = searchSchema({
  query: text,
  time: text,
})

const validatePerformanceTracingTraceSearch = searchSchema({
  overlay: text,
  rootSpanId: text,
  spanId: text,
  activeFilter: text,
  redirectedFrom: text,
  selectedTime: text,
  traceFilter: text,
})

const validateHostMetricsSearch = searchSchema({
  ...dateRangeFields,
  hostnames: text,
  query: text,
  role: text,
})

// The four inspect pages share one shape: a graphs tab plus `fullscreen` (the
// chart the page expands) and the entity list the charts are drawn for.
const validateHostMetricsInspectSearch = searchSchema({
  ...graphsFields,
  fullscreen: text,
  hostnames: text,
})

const validateHostUsageSearch = searchSchema({
  ...dateRangeFields,
  namespaces: text,
  hostnames: text,
  query: text,
})

const validateHostUsageInspectSearch = searchSchema({
  ...graphsFields,
  fullscreen: text,
  namespaces: text,
  hostnames: text,
})

const validateClusterOverviewSearch = searchSchema({
  query: text,
  groupBy: text,
})

const validateClusterPodMetricsSearch = searchSchema({
  ...dateRangeFields,
  query: text,
  state: text,
  namespace: text,
  node_name: text,
})

const validateClusterPodMetricsInspectSearch = searchSchema({
  ...graphsFields,
  fullscreen: text,
  pod_names: text,
})

const validateClusterNodeMetricsSearch = searchSchema({
  ...dateRangeFields,
  query: text,
})

const validateClusterNodeMetricsInspectSearch = searchSchema({
  ...graphsFields,
  fullscreen: text,
  node_names: text,
})

const validateDashboardShowSearch = searchSchema({
  namespaces: text,
  fullscreen: text,
  hostUsageSort: text,
  timeframe: text,
})

const validateAllocationsSearch = searchSchema({
  ...dateRangeFields,
  namespaces: text,
  query: text,
})

const validateNewSiteSearch = searchSchema({
  id: text,
})

const validateNewSiteJsSearch = searchSchema({
  appId: text,
  id: text,
})

const validateNewSiteBrowserSearch = searchSchema({
  appId: text,
})

const validateOrganizationSearch = searchSchema({
  namespace: text,
  environment: text,
  name: text,
})

// `marker` is the version filter; `incident` + `trace_id` drive the error
// inspector sidebar.
const validateBrowserErrorsSearch = searchSchema({
  ...timeRangeFields,
  marker: text,
  incident: text,
  trace_id: text,
  tab: oneOf(BROWSER_ERROR_TABS),
  spanId: text,
})

const validateBrowserPerformanceSearch = searchSchema({
  ...timeRangeFields,
  percentile: text,
  app_versions: text,
  page_urls: text,
})

// --- Leaf routes ---------------------------------------------------------

export const browserErrorsRoute = createRoute({
  component: BrowserErrorsPage,
  getParentRoute: () => appLayoutRoute,
  path: "browser/errors",
  validateSearch: validateBrowserErrorsSearch,
  staticData: {
    componentName: "BrowserErrorsPage",
    menu: "browser",
  },
})

export const browserPerformanceRoute = createRoute({
  component: BrowserPerformancePage,
  getParentRoute: () => appLayoutRoute,
  path: "browser/performance",
  validateSearch: validateBrowserPerformanceSearch,
  staticData: {
    componentName: "BrowserPerformancePage",
    menu: "browser",
  },
})

export const markersIndexRoute = createRoute({
  component: MarkersIndex,
  getParentRoute: () => appLayoutRoute,
  path: "markers",
  validateSearch: validateMarkersSearch,
  staticData: {
    componentName: "MarkersIndex",
  },
})

// Marker detail page. `$revision/$namespace` are own path params on top of the
// inherited `$organizationSlug` / `$appId`. The `$namespace` segment can carry
// an encoded `/` (the page decodes it with `UrlHelper.decodeAction`).
export const markerShowRoute = createRoute({
  component: MarkerShowPage,
  getParentRoute: () => appLayoutRoute,
  path: "markers/$revision/$namespace",
  staticData: {
    componentName: "MarkerShowPage",
  },
})

export const triggersIndexRoute = createRoute({
  component: TriggersPage,
  getParentRoute: () => appLayoutRoute,
  path: "triggers",
  validateSearch: validateTriggersSearch,
  staticData: {
    componentName: "TriggersPage",
  },
})

// Dashboard blank-slate page (`dashboard/add`). The sibling `dashboard` index
// (`DashboardShow`) is still legacy, so this is a standalone leaf rather than a
// child of a `dashboard` layout. The page reads no route state — it only builds
// the `overlay=dashboardForm` link off the current URL.
export const addDashboardRoute = createRoute({
  component: AddDashboardPage,
  getParentRoute: () => appLayoutRoute,
  path: "dashboard/add",
  staticData: {
    componentName: "AddDashboardPage",
  },
})

// Metrics dashboards. `metrics` (index) and `metrics/$id` (a specific
// dashboard) both render `MetricsIndex` as siblings under `appLayoutRoute`.
export const metricsIndexRoute = createRoute({
  component: MetricsIndex,
  getParentRoute: () => appLayoutRoute,
  path: "metrics",
  validateSearch: validateMetricsSearch,
  staticData: {
    componentName: "MetricsIndex",
  },
})

export const metricsShowRoute = createRoute({
  component: MetricsIndex,
  getParentRoute: () => appLayoutRoute,
  path: "metrics/$id",
  validateSearch: validateMetricsSearch,
  staticData: {
    componentName: "MetricsIndex",
  },
})

// The anomaly detection form persists its full configuration in the URL so a
// query can be shared with a colleague. Every field is a string (`tags` is a
// JSON-encoded `MetricTag[]`) and the page serializes/parses them, so nothing
// here narrows — `detector` and `resolution` name their options in the page's
// own selects.
const validateAnomalyDetectionSearch = searchSchema({
  metricName: text,
  field: text,
  timeframe: text,
  resolution: text,
  detector: text,
  ceiling: text,
  minFitQuality: text,
  spikeThreshold: text,
  baselineUntil: text,
  changepointThreshold: text,
  tags: text,
})

// Hidden, unlinked internal tool for running real anomaly detection against a
// metric via the processor's `POST /api/v2/metrics/anomaly` endpoint. Not in the
// navigation — reach it by typing the URL. `menu: "default"` keeps the standard
// site chrome around the page.
export const anomalyDetectionRoute = createRoute({
  component: AnomalyDetectionPage,
  getParentRoute: () => appLayoutRoute,
  path: "anomaly-detection",
  validateSearch: validateAnomalyDetectionSearch,
  staticData: {
    componentName: "AnomalyDetectionPage",
    menu: "default",
  },
})

// Hidden internal tool: steps a metric through the stateful analysis pipeline
// (`POST /api/v2/metrics/analysis_replay`) one observation at a time. Every form
// field is a string, as on the anomaly detection route.
const validateAnalysisReplaySearch = searchSchema({
  metricName: text,
  field: text,
  timeframe: text,
  from: text,
  to: text,
  resolution: text,
  noMatchIsZero: text,
  tags: text,
  shortWindowMinutes: text,
  mediumWindowMinutes: text,
  longWindowMinutes: text,
  trendRefreshMinutes: text,
  warmUpObservations: text,
  deviationBaseline: text,
  deviationThreshold: text,
  minRunLength: text,
  trendThreshold: text,
  rapidTrendRatio: text,
  spreadChangeRatio: text,
  // The stored anomaly event the replay was opened from; the replay starts at its minute.
  triggerId: text,
  eventTimestamp: text,
  eventClassification: text,
})

export const anomalyDetectionTriggersRoute = createRoute({
  component: AnomalyDetectionTriggersPage,
  getParentRoute: () => appLayoutRoute,
  path: "triggers/anomaly-detection",
  staticData: {
    componentName: "AnomalyDetectionTriggersPage",
  },
})

export const anomalyDetectionTriggerRoute = createRoute({
  component: AnomalyDetectionTriggerPage,
  getParentRoute: () => appLayoutRoute,
  path: "triggers/anomaly-detection/$triggerId",
  staticData: {
    componentName: "AnomalyDetectionTriggerPage",
  },
})

export const analysisReplayRoute = createRoute({
  component: AnalysisReplayPage,
  getParentRoute: () => appLayoutRoute,
  path: "analysis-replay",
  validateSearch: validateAnalysisReplaySearch,
  staticData: {
    componentName: "AnalysisReplayPage",
    menu: "default",
  },
})

export const logsIndexRoute = createRoute({
  component: LogsPage,
  getParentRoute: () => appLayoutRoute,
  path: "logs",
  validateSearch: validateLogsSearch,
  staticData: {
    componentName: "LogsPage",
  },
})

// Sibling `logs/*` routes. `logs/$viewId` would otherwise treat static
// siblings like `logs/sources` or `logs/explore` as view IDs, so each sibling
// is its own route and wins over `$viewId` by specificity. The component-less
// ones (e.g. `logs/explore`) are still served by Rails via full-page loads;
// replace each with a real migrated route when that page migrates.
export const logsTriggersRoute = createRoute({
  component: LogsTriggersPage,
  getParentRoute: () => appLayoutRoute,
  path: "logs/triggers",
  validateSearch: validateLogsTriggersSearch,
  staticData: {
    componentName: "LogsTriggersPage",
  },
})

const logsExplorePassthroughRoute = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: "logs/explore",
})

export const logLineActionsRoute = createRoute({
  component: LogLineActionsPage,
  getParentRoute: () => appLayoutRoute,
  path: "logs/actions",
  validateSearch: validateLogLineActionsSearch,
  staticData: {
    componentName: "LogLineActionsPage",
  },
})

export const logsIncidentsRoute = createRoute({
  component: LogsIncidentsPage,
  getParentRoute: () => appLayoutRoute,
  path: "logs/incidents",
  validateSearch: validateLogsIncidentsSearch,
  staticData: {
    componentName: "LogsIncidentsPage",
  },
})

export const logsIncidentRoute = createRoute({
  component: LogsIncidentPage,
  getParentRoute: () => logsIncidentLayoutRoute,
  path: "/",
  validateSearch: validateLogsIncidentSearch,
  staticData: {
    componentName: "LogsIncidentPage",
  },
})

export const logsIncidentLogbookRoute = createRoute({
  component: LogsIncidentLogbookPage,
  getParentRoute: () => logsIncidentLayoutRoute,
  path: "logbook",
  staticData: {
    componentName: "LogsIncidentLogbookPage",
  },
})

export const logsIncidentGraphsRoute = createRoute({
  component: LogsIncidentGraphsPage,
  getParentRoute: () => logsIncidentLayoutRoute,
  path: "graphs",
  validateSearch: validateLogsIncidentGraphsSearch,
  staticData: {
    componentName: "LogsIncidentGraphsPage",
  },
})

export const logsIncidentLinesRoute = createRoute({
  component: LogsIncidentLinesPage,
  getParentRoute: () => logsIncidentLayoutRoute,
  path: "lines",
  staticData: {
    componentName: "LogsIncidentLinesPage",
  },
})

export const sourcesRoute = createRoute({
  component: SourcesPage,
  getParentRoute: () => appLayoutRoute,
  path: "logs/sources",
  validateSearch: validateSourcesSearch,
  staticData: {
    componentName: "SourcesPage",
  },
})

export const sourceRoute = createRoute({
  component: SourcePage,
  getParentRoute: () => appLayoutRoute,
  path: "logs/sources/$logSourceId",
  validateSearch: validateSourceSearch,
  staticData: {
    componentName: "SourcePage",
  },
})

const logsViewExplorePassthroughRoute = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: "logs/$viewId/explore",
})

// Legacy flat route — kept resolving for existing bookmarks/shared links, but
// the app itself now generates `logs/views/$viewId` (see logsLinks.view).
export const logsViewRoute = createRoute({
  component: LogsPage,
  getParentRoute: () => appLayoutRoute,
  path: "logs/$viewId",
  validateSearch: validateLogsSearch,
  staticData: {
    componentName: "LogsPage",
  },
})

export const logsViewsRoute = createRoute({
  component: LogsPage,
  getParentRoute: () => appLayoutRoute,
  path: "logs/views/$viewId",
  validateSearch: validateLogsSearch,
  staticData: {
    componentName: "LogsPage",
  },
})

// Top-level pages — direct children of rootRoute, no shared path prefix.

export const accountsRoute = createRoute({
  component: OrganizationsPage,
  getParentRoute: () => rootRoute,
  path: "accounts",
  staticData: {
    componentName: "OrganizationsPage",
  },
})

// The legacy entry was a `matchRoute` with no name, so it has no named URL helper.
export const assignmentsRoute = createRoute({
  component: AssignmentsPage,
  getParentRoute: () => rootRoute,
  path: "assignments",
  staticData: {
    componentName: "AssignmentsPage",
  },
})

// Org-scoped pages — children of orgLayoutRoute, inherit `organizationSlug`.

export const csvExportsRoute = createRoute({
  component: CsvExportsPage,
  getParentRoute: () => orgLayoutRoute,
  path: "exports",
  staticData: {
    componentName: "CsvExportsPage",
    menu: "organization",
  },
})

export const discoverRoute = createRoute({
  component: DiscoverPage,
  getParentRoute: () => orgLayoutRoute,
  path: "discover",
  staticData: {
    componentName: "DiscoverPage",
    menu: "organization",
  },
})

export const statusPagesRoute = createRoute({
  component: StatusPagesPage,
  getParentRoute: () => orgLayoutRoute,
  path: "status_pages",
  validateSearch: validateStatusPagesSearch,
  staticData: {
    componentName: "StatusPagesPage",
    menu: "organization",
  },
})

export const statusPageRoute = createRoute({
  component: StatusPagesPage,
  getParentRoute: () => orgLayoutRoute,
  path: "status_pages/$id",
  validateSearch: validateStatusPagesSearch,
  staticData: {
    componentName: "StatusPagesPage",
    menu: "organization",
  },
})

// App-scoped check-in pages. The index sits directly under `appLayoutRoute`
// (it has no `$triggerId`); the detail page and its 4 sub-tabs live under
// `checkInLayoutRoute`, inheriting `$triggerId`. The detail page uses
// `path: "/"` to bind to the layout's bare path (`monitors/$triggerId`
// with no trailing segment).

export const checkInsIndexRoute = createRoute({
  component: CheckInsPage,
  getParentRoute: () => appLayoutRoute,
  path: "monitors",
  validateSearch: validateCheckInsSearch,
  staticData: {
    componentName: "CheckInsPage",
  },
})

export const checkInDetailRoute = createRoute({
  component: CheckInPage,
  getParentRoute: () => checkInLayoutRoute,
  path: "/",
  validateSearch: validateCheckInsSearch,
  staticData: {
    componentName: "CheckInPage",
  },
})

export const checkInOccurrencesRoute = createRoute({
  component: CheckInOccurrencesPage,
  getParentRoute: () => checkInLayoutRoute,
  path: "occurrences",
  validateSearch: validateCheckInOccurrencesSearch,
  staticData: {
    componentName: "CheckInOccurrencesPage",
  },
})

export const checkInOccurrenceRoute = createRoute({
  component: CheckInOccurrencePage,
  getParentRoute: () => checkInLayoutRoute,
  path: "occurrences/$id",
  validateSearch: validateCheckInsSearch,
  staticData: {
    componentName: "CheckInOccurrencePage",
  },
})

export const checkInLogbookRoute = createRoute({
  component: CheckInLogbookPage,
  getParentRoute: () => checkInLayoutRoute,
  path: "logbook",
  staticData: {
    componentName: "CheckInLogbookPage",
  },
})

export const checkInInstallationRoute = createRoute({
  component: CheckInInstallationPage,
  getParentRoute: () => checkInLayoutRoute,
  path: "installation",
  staticData: {
    componentName: "CheckInInstallationPage",
  },
})

// Anomaly incident pages. Index sits under `appLayoutRoute`; the detail page
// and its 4 sub-tabs live under `anomalyIncidentLayoutRoute`, inheriting
// `$number`. Detail uses `path: "/"` to bind to the layout's bare path.

export const anomalyIncidentsIndexRoute = createRoute({
  component: AnomalyIncidentsPage,
  getParentRoute: () => appLayoutRoute,
  path: "anomalies",
  validateSearch: validateAnomalyIncidentsSearch,
  staticData: {
    componentName: "AnomalyIncidentsPage",
  },
})

export const anomalyIncidentPageRoute = createRoute({
  component: AnomalyIncidentPage,
  getParentRoute: () => anomalyIncidentLayoutRoute,
  path: "/",
  staticData: {
    componentName: "AnomalyIncidentPage",
  },
})

export const anomalyIncidentAlertsRoute = createRoute({
  component: AnomalyIncidentAlertsPage,
  getParentRoute: () => anomalyIncidentLayoutRoute,
  path: "alerts",
  validateSearch: validateAnomalyIncidentAlertsSearch,
  staticData: {
    componentName: "AnomalyIncidentAlertsPage",
  },
})

export const anomalyIncidentAlertRoute = createRoute({
  component: AnomalyIncidentAlertPage,
  getParentRoute: () => anomalyIncidentLayoutRoute,
  path: "alerts/$id",
  staticData: {
    componentName: "AnomalyIncidentAlertPage",
  },
})

export const anomalyIncidentLogbookRoute = createRoute({
  component: AnomalyIncidentLogbookPage,
  getParentRoute: () => anomalyIncidentLayoutRoute,
  path: "logbook",
  staticData: {
    componentName: "AnomalyIncidentLogbookPage",
  },
})

export const anomalyIncidentGraphsRoute = createRoute({
  component: AnomalyIncidentGraphsPage,
  getParentRoute: () => anomalyIncidentLayoutRoute,
  path: "graphs",
  validateSearch: validateAnomalyIncidentGraphsSearch,
  staticData: {
    componentName: "AnomalyIncidentGraphsPage",
  },
})

export const eventsIndexRoute = createRoute({
  component: EventsIndex,
  getParentRoute: () => appLayoutRoute,
  path: "events",
  validateSearch: validateDateRangeSearch,
  staticData: {
    componentName: "EventsIndex",
  },
})

export const eventGroupShowRoute = createRoute({
  component: EventGroupShow,
  getParentRoute: () => appLayoutRoute,
  path: "events/$group",
  validateSearch: validateDateRangeSearch,
  staticData: {
    componentName: "EventGroupShow",
  },
})

export const slowEventsRoute = createRoute({
  component: EventPage,
  getParentRoute: () => appLayoutRoute,
  path: "improve/$group",
  validateSearch: validateDateRangeSearch,
  staticData: {
    componentName: "EventPage",
  },
})

export const slowEventRoute = createRoute({
  component: EventPage,
  getParentRoute: () => appLayoutRoute,
  path: "improve/$group/$id",
  validateSearch: validateDateRangeSearch,
  staticData: {
    componentName: "EventPage",
  },
})

export const uptimeMonitorsRoute = createRoute({
  component: UptimeMonitorPage,
  getParentRoute: () => appLayoutRoute,
  path: "uptime_monitors",
  validateSearch: validateUptimeMonitorsSearch,
  staticData: {
    componentName: "UptimeMonitorPage",
  },
})

export const uptimeMonitorRoute = createRoute({
  component: UptimeMonitorPage,
  getParentRoute: () => appLayoutRoute,
  path: "uptime_monitors/$id",
  validateSearch: validateUptimeMonitorsSearch,
  staticData: {
    componentName: "UptimeMonitorPage",
  },
})

export const exceptionIncidentsRoute = createRoute({
  component: ExceptionIncidentsPage,
  getParentRoute: () => appLayoutRoute,
  path: "exceptions",
  validateSearch: validateExceptionIncidentsSearch,
  staticData: {
    componentName: "ExceptionIncidentsPage",
  },
})

export const exceptionIncidentsGraphsRoute = createRoute({
  component: ExceptionIncidentsGraphs,
  getParentRoute: () => appLayoutRoute,
  path: "exceptions/graphs",
  validateSearch: validateExceptionIncidentsGraphsSearch,
  staticData: {
    componentName: "ExceptionIncidentsGraphs",
  },
})

export const exceptionIncidentsViewRoute = createRoute({
  component: ExceptionIncidentsPage,
  getParentRoute: () => appLayoutRoute,
  path: "exceptions/views/$viewId",
  validateSearch: validateExceptionIncidentsSearch,
  staticData: {
    componentName: "ExceptionIncidentsPage",
  },
})

export const exceptionIncidentRoute = createRoute({
  component: ExceptionIncidentPage,
  getParentRoute: () => exceptionIncidentLayoutRoute,
  path: "/",
  staticData: {
    componentName: "ExceptionIncidentPage",
  },
})

export const exceptionIncidentTracesRoute = createRoute({
  component: ExceptionIncidentTracesPage,
  getParentRoute: () => exceptionIncidentLayoutRoute,
  path: "traces",
  validateSearch: validateExceptionIncidentTracesSearch,
  staticData: {
    componentName: "ExceptionIncidentTracesPage",
  },
})

export const exceptionIncidentLogbookRoute = createRoute({
  component: ExceptionIncidentLogbookPage,
  getParentRoute: () => exceptionIncidentLayoutRoute,
  path: "logbook",
  staticData: {
    componentName: "ExceptionIncidentLogbookPage",
  },
})

export const exceptionIncidentAttributesRoute = createRoute({
  component: ExceptionIncidentAttributesPage,
  getParentRoute: () => exceptionIncidentLayoutRoute,
  path: "attributes",
  staticData: {
    componentName: "ExceptionIncidentAttributesPage",
  },
})

export const exceptionIncidentGraphsRoute = createRoute({
  component: ExceptionIncidentGraphsPage,
  getParentRoute: () => exceptionIncidentLayoutRoute,
  path: "graphs",
  validateSearch: validateExceptionIncidentGraphsSearch,
  staticData: {
    componentName: "ExceptionIncidentGraphsPage",
  },
})

export const exceptionIncidentTraceRoute = createRoute({
  component: ExceptionIncidentTracePage,
  getParentRoute: () => exceptionIncidentLayoutRoute,
  path: "traces/$traceId",
  validateSearch: validateExceptionIncidentTraceSearch,
  staticData: {
    componentName: "ExceptionIncidentTracePage",
  },
})

export const exceptionIncidentTraceTimestampRoute = createRoute({
  component: ExceptionIncidentTraceTimestampPage,
  getParentRoute: () => exceptionIncidentLayoutRoute,
  path: "traces/time/$timestamp",
  staticData: {
    componentName: "ExceptionIncidentTraceTimestampPage",
  },
})

export const performanceIncidentsRoute = createRoute({
  component: PerformanceIncidentsPage,
  getParentRoute: () => appLayoutRoute,
  path: "performance",
  validateSearch: validatePerformanceIncidentsSearch,
  staticData: {
    componentName: "PerformanceIncidentsPage",
  },
})

export const performanceIncidentsGraphsRoute = createRoute({
  component: PerformanceIncidentsGraphs,
  getParentRoute: () => appLayoutRoute,
  path: "performance/graphs",
  validateSearch: validatePerformanceIncidentsGraphsSearch,
  staticData: {
    componentName: "PerformanceIncidentsGraphs",
  },
})

export const performanceApdexRoute = createRoute({
  component: PerformanceApdexPage,
  getParentRoute: () => appLayoutRoute,
  path: "performance/apdex",
  validateSearch: validatePerformanceApdexSearch,
  staticData: {
    componentName: "PerformanceApdexPage",
  },
})

export const performanceIncidentRoute = createRoute({
  component: PerformanceIncidentPage,
  getParentRoute: () => performanceIncidentLayoutRoute,
  path: "/",
  staticData: {
    componentName: "PerformanceIncidentPage",
  },
})

export const performanceIncidentSamplesRoute = createRoute({
  component: PerformanceIncidentSamplesPage,
  getParentRoute: () => performanceIncidentLayoutRoute,
  path: "samples",
  validateSearch: validatePerformanceIncidentSamplesSearch,
  staticData: {
    componentName: "PerformanceIncidentSamplesPage",
  },
})

export const performanceIncidentGraphsRoute = createRoute({
  component: PerformanceIncidentGraphsPage,
  getParentRoute: () => performanceIncidentLayoutRoute,
  path: "graphs",
  validateSearch: validatePerformanceIncidentGraphsSearch,
  staticData: {
    componentName: "PerformanceIncidentGraphsPage",
  },
})

export const performanceIncidentLogbookRoute = createRoute({
  component: PerformanceIncidentLogbookPage,
  getParentRoute: () => performanceIncidentLayoutRoute,
  path: "logbook",
  staticData: {
    componentName: "PerformanceIncidentLogbookPage",
  },
})

export const performanceIncidentSampleRoute = createRoute({
  component: PerformanceIncidentSamplePage,
  getParentRoute: () => performanceIncidentLayoutRoute,
  path: "samples/$sampleId",
  validateSearch: validatePerformanceIncidentSampleSearch,
  staticData: {
    componentName: "PerformanceIncidentSamplePage",
  },
})

export const performanceIncidentSampleTimestampRoute = createRoute({
  component: PerformanceIncidentSamplePage,
  getParentRoute: () => performanceIncidentLayoutRoute,
  path: "samples/timestamp/$timestamp",
  validateSearch: validatePerformanceIncidentSampleSearch,
  staticData: {
    componentName: "PerformanceIncidentSamplePage",
  },
})

export const performanceTracingActionsRoute = createRoute({
  component: PerformanceTracingActionsPage,
  getParentRoute: () => appLayoutRoute,
  path: "performance/traces",
  validateSearch: validatePerformanceTracingActionsSearch,
  staticData: {
    componentName: "PerformanceTracingActionsPage",
  },
})

export const performanceTracingActionRoute = createRoute({
  component: PerformanceTracingActionPage,
  getParentRoute: () => performanceTracingActionLayoutRoute,
  path: "/",
  staticData: {
    componentName: "PerformanceTracingActionPage",
  },
})

export const performanceTracingGraphsRoute = createRoute({
  component: PerformanceTracingGraphsPage,
  getParentRoute: () => performanceTracingActionLayoutRoute,
  path: "graphs",
  validateSearch: validatePerformanceTracingGraphsSearch,
  staticData: {
    componentName: "PerformanceTracingGraphsPage",
  },
})

export const performanceTracingLogbookRoute = createRoute({
  component: PerformanceTracingLogbookPage,
  getParentRoute: () => performanceTracingActionLayoutRoute,
  path: "logbook",
  staticData: {
    componentName: "PerformanceTracingLogbookPage",
  },
})

export const performanceTracingTracesRoute = createRoute({
  component: PerformanceTracingTracesPage,
  getParentRoute: () => performanceTracingActionLayoutRoute,
  path: "traces",
  validateSearch: validatePerformanceTracingTracesSearch,
  staticData: {
    componentName: "PerformanceTracingTracesPage",
  },
})

export const performanceTracingTraceRoute = createRoute({
  component: PerformanceTracingTracePage,
  getParentRoute: () => performanceTracingActionLayoutRoute,
  path: "traces/$traceId",
  validateSearch: validatePerformanceTracingTraceSearch,
  staticData: {
    componentName: "PerformanceTracingTracePage",
  },
})

export const hostMetricsIndexRoute = createRoute({
  component: HostMetricsPage,
  getParentRoute: () => appLayoutRoute,
  path: "host_metrics",
  validateSearch: validateHostMetricsSearch,
  staticData: {
    componentName: "HostMetricsPage",
  },
})

export const hostMetricsInspectRoute = createRoute({
  component: HostMetricsInspectPage,
  getParentRoute: () => appLayoutRoute,
  path: "host_metrics/inspect",
  validateSearch: validateHostMetricsInspectSearch,
  staticData: {
    componentName: "HostMetricsInspectPage",
  },
})

export const hostUsageIndexRoute = createRoute({
  component: HostUsagePage,
  getParentRoute: () => appLayoutRoute,
  path: "host_usage",
  validateSearch: validateHostUsageSearch,
  staticData: {
    componentName: "HostUsagePage",
  },
})

export const hostUsageInspectRoute = createRoute({
  component: HostUsageInspectPage,
  getParentRoute: () => appLayoutRoute,
  path: "host_usage/inspect",
  validateSearch: validateHostUsageInspectSearch,
  staticData: {
    componentName: "HostUsageInspectPage",
  },
})

export const clusterOverviewRoute = createRoute({
  component: ClusterOverviewPage,
  getParentRoute: () => appLayoutRoute,
  path: "cluster",
  validateSearch: validateClusterOverviewSearch,
  staticData: {
    componentName: "ClusterOverviewPage",
  },
})

export const clusterPodMetricsRoute = createRoute({
  component: ClusterPodMetricsPage,
  getParentRoute: () => appLayoutRoute,
  path: "cluster/pod_metrics",
  validateSearch: validateClusterPodMetricsSearch,
  staticData: {
    componentName: "ClusterPodMetricsPage",
  },
})

export const clusterPodMetricsInspectRoute = createRoute({
  component: ClusterPodMetricsInspectPage,
  getParentRoute: () => appLayoutRoute,
  path: "cluster/pod_metrics/inspect",
  validateSearch: validateClusterPodMetricsInspectSearch,
  staticData: {
    componentName: "ClusterPodMetricsInspectPage",
  },
})

export const clusterNodeMetricsRoute = createRoute({
  component: ClusterNodeMetricsPage,
  getParentRoute: () => appLayoutRoute,
  path: "cluster/node_metrics",
  validateSearch: validateClusterNodeMetricsSearch,
  staticData: {
    componentName: "ClusterNodeMetricsPage",
  },
})

export const clusterNodeMetricsInspectRoute = createRoute({
  component: ClusterNodeMetricsInspectPage,
  getParentRoute: () => appLayoutRoute,
  path: "cluster/node_metrics/inspect",
  validateSearch: validateClusterNodeMetricsInspectSearch,
  staticData: {
    componentName: "ClusterNodeMetricsInspectPage",
  },
})

export const dashboardShowRoute = createRoute({
  component: DashboardShow,
  getParentRoute: () => appLayoutRoute,
  path: "dashboard",
  validateSearch: validateDashboardShowSearch,
  staticData: {
    componentName: "DashboardShow",
  },
})

export const allocationsPageRoute = createRoute({
  component: AllocationsPage,
  getParentRoute: () => appLayoutRoute,
  path: "allocations",
  validateSearch: validateAllocationsSearch,
  staticData: {
    componentName: "AllocationsPage",
  },
})

// --- Site-creation wizard ------------------------------------------------
//
// Children of `orgLayoutRoute` (NOT `appLayoutRoute`): they sit at
// `sites/create` and `sites/new/...`, siblings of the `sites/$appId` app tree.
// The static `create`/`new` segments win over `$appId` by specificity, so they
// resolve despite sharing the `sites/` prefix.
//
// `SiteNew` switches only on the first segment after `new` (`$language`) and
// reads `organizationSlug` / `language` / `id` (plus step navigation derived
// from `currentPath`) off the drilled `params` blob — it never imports
// `useCurrentParams`. Legacy enumerated `SiteNew` at 1–4 segments after `new`;
// we mirror those depths so the same URLs render client-side (deeper URLs fall
// through to Rails, as before). Param names are kept consistent across depths
// (`$language` → `$languageStep` → `$framework` → `$frameworkStep`) because
// TanStack forbids differently-named params at the same trie position; only
// `$language` is read, so the rest are positional placeholders (this is why the
// legacy 2-segment `:step` becomes `$languageStep`). The wizard keeps reading
// the drilled blob: reading `language` via the loose hook would blank it
// during the stale-render window and flash the language picker.
// `js` is special-cased to `NewSiteJs`, and `browser` to `BrowserSdkWizard`,
// both winning over `$language` as static segments.

export const siteCreateRoute = createRoute({
  component: SiteCreate,
  getParentRoute: () => orgLayoutRoute,
  path: "sites/create",
  staticData: {
    componentName: "SiteCreate",
    menu: "none",
  },
})

export const newSiteRoute = createRoute({
  component: AddAppPage,
  getParentRoute: () => orgLayoutRoute,
  path: "sites/new",
  validateSearch: validateNewSiteSearch,
  staticData: {
    componentName: "AddAppPage",
    menu: "none",
  },
})

export const newSiteManualRoute = createRoute({
  component: SiteNew,
  getParentRoute: () => orgLayoutRoute,
  path: "sites/new/manual",
  validateSearch: validateNewSiteSearch,
  staticData: {
    componentName: "SiteNew",
    menu: "none",
  },
})

export const newSiteBrowserRoute = createRoute({
  component: BrowserSdkWizard,
  getParentRoute: () => orgLayoutRoute,
  path: "sites/new/browser",
  validateSearch: validateNewSiteBrowserSearch,
  staticData: {
    componentName: "BrowserSdkWizard",
    menu: "none",
  },
})

export const newSiteBrowserStepRoute = createRoute({
  component: BrowserSdkWizard,
  getParentRoute: () => orgLayoutRoute,
  path: "sites/new/browser/$step",
  validateSearch: validateNewSiteBrowserSearch,
  staticData: {
    componentName: "BrowserSdkWizard",
    menu: "none",
  },
})

export const newSiteProvisioningRoute = createRoute({
  component: ProvisioningPage,
  getParentRoute: () => orgLayoutRoute,
  path: "sites/new/provisioning",
  staticData: {
    componentName: "ProvisioningPage",
    menu: "none",
  },
})

export const newSiteJsRoute = createRoute({
  component: NewSiteJs,
  getParentRoute: () => orgLayoutRoute,
  path: "sites/new/js",
  validateSearch: validateNewSiteJsSearch,
  staticData: {
    componentName: "NewSiteJs",
    menu: "none",
  },
})

export const newSiteJsStepRoute = createRoute({
  component: NewSiteJs,
  getParentRoute: () => orgLayoutRoute,
  path: "sites/new/js/$step",
  validateSearch: validateNewSiteJsSearch,
  staticData: {
    componentName: "NewSiteJs",
    menu: "none",
  },
})

export const newSiteLanguageRoute = createRoute({
  component: SiteNew,
  getParentRoute: () => orgLayoutRoute,
  path: "sites/new/$language",
  validateSearch: validateNewSiteSearch,
  staticData: {
    componentName: "SiteNew",
    menu: "none",
  },
})

export const newSiteLanguageStepRoute = createRoute({
  component: SiteNew,
  getParentRoute: () => orgLayoutRoute,
  path: "sites/new/$language/$languageStep",
  validateSearch: validateNewSiteSearch,
  staticData: {
    componentName: "SiteNew",
    menu: "none",
  },
})

export const newSiteFrameworkRoute = createRoute({
  component: SiteNew,
  getParentRoute: () => orgLayoutRoute,
  path: "sites/new/$language/$languageStep/$framework",
  validateSearch: validateNewSiteSearch,
  staticData: {
    componentName: "SiteNew",
    menu: "none",
  },
})

export const newSiteFrameworkStepRoute = createRoute({
  component: SiteNew,
  getParentRoute: () => orgLayoutRoute,
  path: "sites/new/$language/$languageStep/$framework/$frameworkStep",
  validateSearch: validateNewSiteSearch,
  staticData: {
    componentName: "SiteNew",
    menu: "none",
  },
})

export const showOrganizationRoute = createRoute({
  component: OrganizationPage,
  getParentRoute: () => orgLayoutRoute,
  path: "/",
  validateSearch: validateOrganizationSearch,
  staticData: {
    componentName: "OrganizationPage",
    menu: "organization",
  },
})

// Full nested tree consumed by `routeTree.ts`. Layout routes wrap their
// leaves; new leaves slot in under the matching layout.
export const ROUTE_TREE = [
  accountsRoute,
  assignmentsRoute,
  orgLayoutRoute.addChildren([
    showOrganizationRoute,
    csvExportsRoute,
    discoverRoute,
    statusPagesRoute,
    statusPageRoute,
    siteCreateRoute,
    newSiteRoute,
    newSiteManualRoute,
    newSiteBrowserRoute,
    newSiteBrowserStepRoute,
    newSiteProvisioningRoute,
    newSiteJsRoute,
    newSiteJsStepRoute,
    newSiteLanguageRoute,
    newSiteLanguageStepRoute,
    newSiteFrameworkRoute,
    newSiteFrameworkStepRoute,
    appLayoutRoute.addChildren([
      browserErrorsRoute,
      browserPerformanceRoute,
      markersIndexRoute,
      markerShowRoute,
      triggersIndexRoute,
      addDashboardRoute,
      metricsIndexRoute,
      metricsShowRoute,
      anomalyDetectionRoute,
      analysisReplayRoute,
      anomalyDetectionTriggersRoute,
      anomalyDetectionTriggerRoute,
      logsIndexRoute,
      logsTriggersRoute,
      logsExplorePassthroughRoute,
      logLineActionsRoute,
      logsIncidentsRoute,
      logsIncidentLayoutRoute.addChildren([
        logsIncidentRoute,
        logsIncidentLogbookRoute,
        logsIncidentGraphsRoute,
        logsIncidentLinesRoute,
      ]),
      sourcesRoute,
      sourceRoute,
      logsViewExplorePassthroughRoute,
      logsViewRoute,
      logsViewsRoute,
      checkInsIndexRoute,
      checkInLayoutRoute.addChildren([
        checkInDetailRoute,
        checkInOccurrencesRoute,
        checkInOccurrenceRoute,
        checkInLogbookRoute,
        checkInInstallationRoute,
      ]),
      eventsIndexRoute,
      eventGroupShowRoute,
      slowEventsRoute,
      slowEventRoute,
      uptimeMonitorsRoute,
      uptimeMonitorRoute,
      anomalyIncidentsIndexRoute,
      anomalyIncidentLayoutRoute.addChildren([
        anomalyIncidentPageRoute,
        anomalyIncidentAlertsRoute,
        anomalyIncidentAlertRoute,
        anomalyIncidentLogbookRoute,
        anomalyIncidentGraphsRoute,
      ]),
      exceptionIncidentsRoute,
      exceptionIncidentsGraphsRoute,
      exceptionIncidentsViewRoute,
      exceptionIncidentLayoutRoute.addChildren([
        exceptionIncidentRoute,
        exceptionIncidentTracesRoute,
        exceptionIncidentLogbookRoute,
        exceptionIncidentAttributesRoute,
        exceptionIncidentGraphsRoute,
        exceptionIncidentTraceRoute,
        exceptionIncidentTraceTimestampRoute,
      ]),
      performanceIncidentsRoute,
      performanceIncidentsGraphsRoute,
      performanceApdexRoute,
      performanceIncidentLayoutRoute.addChildren([
        performanceIncidentRoute,
        performanceIncidentSamplesRoute,
        performanceIncidentGraphsRoute,
        performanceIncidentLogbookRoute,
        performanceIncidentSampleRoute,
        performanceIncidentSampleTimestampRoute,
      ]),
      performanceTracingActionsRoute,
      performanceTracingActionLayoutRoute.addChildren([
        performanceTracingActionRoute,
        performanceTracingGraphsRoute,
        performanceTracingLogbookRoute,
        performanceTracingTracesRoute,
        performanceTracingTraceRoute,
      ]),
      hostMetricsIndexRoute,
      hostMetricsInspectRoute,
      hostUsageIndexRoute,
      hostUsageInspectRoute,
      clusterOverviewRoute,
      clusterPodMetricsRoute,
      clusterPodMetricsInspectRoute,
      clusterNodeMetricsRoute,
      clusterNodeMetricsInspectRoute,
      dashboardShowRoute,
      allocationsPageRoute,
    ]),
  ]),
]
